module.exports = "/_next/static/images/header-icons-d8078a6f.png";